module.exports = __webpack_public_path__ + "img/car_sendai12.2d902190.jpg";